import { createReducer } from '@reduxjs/toolkit'

import { campaignsSummaryTableColumnsConfig } from 'configuration/tables/campaignFactsTables'
import {
    ADVANCED_AUTOMATIONS,
    ADVANCED_TEXT,
    AUTOMATION_PROFILES,
    BID_MULTIPLIERS,
    BRANDS,
    CAMPAIGN_AD_FORMATS,
    CAMPAIGN_NAME,
    CAMPAIGN_START_DATE,
    CAMPAIGN_STATES,
    CAMPAIGN_TARGETING_TYPES,
    CAMPAIGNS,
    COUNTRIES,
    DATES,
    FACT_TYPES,
    LABELS,
    METRIC_FILTERS,
    PORTFOLIOS,
    REGIONS,
} from 'const/filters'
import { FILTER_SETTINGS, FILTERS } from 'const/reducerKeys'
import {
    ENABLED,
    CAMPAIGN_STATES as CAMPAIGN_STATES_OPTIONS,
} from 'const/resourceStates'
import { serializeColumns } from 'helpers/tables'
import { getDefaultTable } from 'reducers/ui/defaults'

import { defaultPage } from '../defaults'

const defaultState = {
    ...defaultPage,
    [FILTERS]: {
        [CAMPAIGN_NAME]: null,
        [FACT_TYPES]: [],
        [REGIONS]: [],
        [COUNTRIES]: [],
        [BRANDS]: [],
        [PORTFOLIOS]: [],
        [CAMPAIGNS]: [],
        [CAMPAIGN_STATES]: [
            {
                value: ENABLED,
                label: CAMPAIGN_STATES_OPTIONS[ENABLED],
            },
        ],
        [CAMPAIGN_START_DATE]: [],
        [CAMPAIGN_TARGETING_TYPES]: [],
        [CAMPAIGN_AD_FORMATS]: [],
        [ADVANCED_AUTOMATIONS]: [],
        [AUTOMATION_PROFILES]: [],
        [ADVANCED_TEXT]: [],
        [LABELS]: [],
        [METRIC_FILTERS]: [],
        [BID_MULTIPLIERS]: [],
    },
    [FILTER_SETTINGS]: {
        anchored: [CAMPAIGN_NAME, DATES],
        order: [
            FACT_TYPES,
            METRIC_FILTERS,
            REGIONS,
            COUNTRIES,
            BRANDS,
            PORTFOLIOS,
            CAMPAIGNS,
            CAMPAIGN_START_DATE,
            CAMPAIGN_STATES,
            CAMPAIGN_TARGETING_TYPES,
            CAMPAIGN_AD_FORMATS,
            ADVANCED_AUTOMATIONS,
            AUTOMATION_PROFILES,
            ADVANCED_TEXT,
            LABELS,
            BID_MULTIPLIERS,
        ],
        displayState: {
            [FACT_TYPES]: true,
            [METRIC_FILTERS]: true,
            [REGIONS]: true,
            [COUNTRIES]: true,
            [BRANDS]: true,
            [PORTFOLIOS]: true,
            [CAMPAIGNS]: true,
            [CAMPAIGN_START_DATE]: true,
            [CAMPAIGN_STATES]: true,
            [CAMPAIGN_TARGETING_TYPES]: true,
            [ADVANCED_AUTOMATIONS]: true,
            [AUTOMATION_PROFILES]: true,
            [ADVANCED_TEXT]: true,
            [LABELS]: true,
            [BID_MULTIPLIERS]: true,
        },
        userAdded: [CAMPAIGN_STATES],
    },
    table: getDefaultTable(
        serializeColumns(campaignsSummaryTableColumnsConfig),
        {
            showTotalRow: true,
            sorter: {
                field: 'amazon_sales',
                order: 'descend',
            },
        }
    ),
}

export default createReducer(defaultState, () => {})
